import React, { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';

import { Select } from '~components';

import { DashboardCaseManagerFilter } from '~support-at-home/models/dashboard';

import { getAll as getAllUsers } from '~care-workers/actions';

import { selectCaseManagerUsers } from '~care-workers/selectors/users';

import { DASHBOARD_TEXT } from './dashboardText';

interface ComponentProps {
  value: DashboardCaseManagerFilter;
  onChange: (value: DashboardCaseManagerFilter) => void;
  disabled?: boolean;
}

const copy = DASHBOARD_TEXT.filter;

/** The Dashboard's case manager filter: all, clients with none, or one case manager. Users load once on mount. */
export const CaseManagerSelect: React.FC<ComponentProps> = ({ value, onChange, disabled = false }) => {
  const dispatch = useAppDispatch();
  const caseManagers = useAppSelector(selectCaseManagerUsers);

  useEffect(() => {
    dispatch(getAllUsers());
  }, []);

  const options = useMemo(
    () => [
      { value: 'all', label: copy.all },
      { value: 'unassigned', label: copy.unassigned },
      ...[...caseManagers]
        .sort((a, b) => a.name.localeCompare(b.name, 'en-AU', { sensitivity: 'base' }))
        .map(({ id, name }) => ({ value: id, label: name })),
    ],
    [caseManagers],
  );

  return (
    <Select
      id="dashboard-case-manager-select"
      name="dashboard-case-manager-select"
      ariaLabel={copy.label}
      options={options}
      value={value}
      onChange={(_, selected) =>
        onChange(selected === 'all' || selected === 'unassigned' ? selected : Number(selected))
      }
      className="case-manager"
      disabled={disabled}
    />
  );
};
